module.exports = __webpack_public_path__ + "img/降香（印度黄檀）.556bc102.jpg";